import * as React from "react";
import { forwardRef } from "react";
const SvgCaretDown = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 6, viewBox: "0 0 12 6", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0 0L6 6L12 0H0Z", fill: "#89A6FF" }));
const ForwardRef = forwardRef(SvgCaretDown);
export { ForwardRef as ReactComponent };
